// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap'
import './assets/bootstrap-theme.min.css';
import './assets/style.css';
import 'nprogress/nprogress.css';
import 'open-iconic/font/css/open-iconic-bootstrap.css';
//import 'vue2-dropzone/dist/vue2Dropzone.css'

import Vue from 'vue'
Vue.config.debug = true
import App from './App'
import router from '@/router'
import http from './services/http'

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

import Breadcrumb from "@/components/Breadcrumb";
Vue.component('breadcrumb', Breadcrumb);

import AlertMessage from "@/components/AlertMessage";
Vue.component('alertMessage', AlertMessage);

Vue.prototype.$http = http;
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js